<eze-registration-closed formName="Owner" [url]="eventUrl" *ngIf="isClosed"></eze-registration-closed>

<eze-smart-form-container *ngIf="!isClosed">
	<div header>
		<h1>School Owner Registration</h1>
	</div>
	<div body>

		<div [innerHtml]="successHtml" *ngIf="successHtml" style="margin: 20px;"></div>

		<div *ngIf="!successHtml">
			<form novalidate [formGroup]="form" (ngSubmit)="onSubmit()">
				<fieldset>
					<eze-registration-closing-warning formName="owner"></eze-registration-closing-warning>

					<eze-alert></eze-alert>

					<div class="row">
						<div class="col-sm-4">
							<eze-input-container label="First Name">
								<input ezeInput type="text" id="name_first" [showValidation]="showValidation" formControlName="name_first"
								    [showValidation]="showValidation">
							</eze-input-container>
						</div>
						<div class="col-sm-4">
							<eze-input-container label="Middle Name">
								<input ezeInput type="text" id="name_middle" [showValidation]="showValidation" formControlName="name_middle">
							</eze-input-container>
						</div>
						<div class="col-sm-4">
							<eze-input-container label="Last Name">
								<input ezeInput type="text" id="name_last" [showValidation]="showValidation" formControlName="name_last">
							</eze-input-container>
						</div>

						<div class="clearfix"></div>

						<div class="col-sm-4">
							<eze-input-container>
								<select ezeInput id="gender" [showValidation]="showValidation" formControlName="gender">
									<option value="">Select...</option>
									<option *ngFor="let gender of ['Male', 'Female']" [value]="gender">{{gender}}</option>
								</select>
							</eze-input-container>
						</div>

					</div>

					<eze-birth-date formControlName="birth_date" [showValidation]="showValidation" [youngestAge]="18"></eze-birth-date>

				</fieldset>
				<fieldset>

					<!-- contact -->
					<eze-contact [formGroup]="form" [showValidation]="showValidation"></eze-contact>

				</fieldset>

				<fieldset *ngIf="form.get('document_id')">
					<eze-event-image-upload [eventId]="eventId" formControlName="document_id" [showValidation]="showValidation"></eze-event-image-upload>
				</fieldset>

				<fieldset>
					<eze-alert #schoolAlert></eze-alert>

					<div class="row">
						<!--<div class="col-sm-6">
							<eze-input-container>
								<select ezeInput type="text" id="shirt_size" [showValidation]="showValidation" formControlName="shirt_size">
									<option value="">Please Select...</option>
									<option *ngFor="let size of shirtSizes" [value]="size">{{size}}</option>
								</select>
							</eze-input-container>
						</div>-->

						<div class="col-xs-12">
							<h3>Select a school to claim</h3>
						</div>

						<div class="col-xs-12" formGroupName="school">
							<eze-input-container>
								<select ezeInput type="text" id="school" [showValidation]="showValidation" formControlName="id" required>
									<option value="null" disabled>Please Select...</option>
									<option *ngFor="let school of schools" [value]="school.id">{{school.name}} - ({{school.city}})</option>
									<option value="-1">
										Add New School
									</option>
								</select>
							</eze-input-container>
							<small>Please select 'Add New School' if your school is not in this list.</small>
						</div>

					</div>

					<br>

					<div *ngIf="showSchoolDetails()">
						<h3 *ngIf="form.get('school.id').value === '-1'">Add New School</h3>
						<h3 *ngIf="form.get('school.id').value !== '-1'">Verify School Information</h3>

						<div class="row" formGroupName="school">
							<div class="col-sm-12">
								<eze-input-container required>
									<input ezeInput type="text" id="name" [showValidation]="showValidation" formControlName="name" [externalError]="form.get('school').getError('name')">
								</eze-input-container>
							</div>

							<div class="col-sm-12">
								<eze-input-container required>
									<input ezeInput type="text" id="master" [showValidation]="showValidation" formControlName="master"
									    [externalError]="form.get('school').getError('master')">
								</eze-input-container>
							</div>


							<div class="col-sm-12">
								<eze-input-container required>
									<input ezeInput type="text" id="address" [showValidation]="showValidation" formControlName="address"
									    [externalError]="form.get('school').getError('address')">
								</eze-input-container>
							</div>

							<div class="col-sm-12">
								<eze-input-container>
									<input ezeInput type="text" id="address_2" [showValidation]="showValidation" formControlName="address_2">
								</eze-input-container>
							</div>

							<div class="col-sm-5">
								<eze-input-container required>
									<input ezeInput type="text" id="city" [showValidation]="showValidation" formControlName="city" [externalError]="form.get('school').getError('city')">
								</eze-input-container>
							</div>

							<div class="col-xs-6 col-sm-3">
								<eze-input-container label="State" required>
									<select ezeInput id="school_state" [showValidation]="showValidation" formControlName="state" [externalError]="form.get('school').getError('state')">
										<option value="">Select...</option>
										<option *ngFor="let state of stateList" [value]="state">{{state}}</option>
									</select>
								</eze-input-container>
							</div>

							<div class="col-xs-6 col-sm-4">
								<eze-input-container required>
									<input ezeInput type="text" id="zip" [showValidation]="showValidation" formControlName="zip" [externalError]="form.get('school').getError('zip')">
								</eze-input-container>
							</div>

							<div class="clearfix"></div>

							<div class="col-sm-6">
								<eze-input-container>
									<input ezeInput type="text" id="country" [showValidation]="showValidation" formControlName="country">
								</eze-input-container>
							</div>

							<div class="col-sm-6">
								<eze-input-container label="Website">
									<input ezeInput type="text" id="url" [showValidation]="showValidation" formControlName="url">
								</eze-input-container>
							</div>

							<div class="col-sm-6">
								<eze-input-container required>
									<input ezeInput type="text" id="phone" [showValidation]="showValidation" formControlName="phone" [textMask]="{mask: getPhoneMask('school.phone'), guide: false}"
									    [externalError]="form.get('school').getError('phone')">
								</eze-input-container>
							</div>

							<div class="col-sm-6">
								<eze-input-container>
									<input ezeInput type="text" id="email" [showValidation]="showValidation" formControlName="email">
								</eze-input-container>
							</div>
						</div>
					</div>

				</fieldset>

				<fieldset>
					<div class="row">
						<div class="col-xs-12">
							<h3>Optional Guest Information</h3>
						</div>
						<div class="col-xs-6">
							<eze-input-container>
								<input ezeInput type="text" id="guest_name_first" formControlName="guest_name_first" [showValidation]="showValidation">
							</eze-input-container>
						</div>

						<div class="col-xs-6">
							<eze-input-container>
								<input ezeInput type="text" id="guest_name_last" formControlName="guest_name_last" [showValidation]="showValidation">
							</eze-input-container>
						</div>
					</div>
				</fieldset>

				<fieldset>
					<eze-input-container label="I want to subscribe to emails">
						<input ezeInput type="checkbox" id="subscription" formControlName="subscription" [showValidation]="showValidation">
					</eze-input-container>

					<eze-input-container label="*By clicking this box I attest that I am the owner of the school listed above. I have read and fully understood the Liability Waiver, the Image Release, the Medical Treatment and the Terms and Conditions.  I attest that the information I have provided is true and correct.  I understand that this registration will be verified via email and/or phone.">
						<input ezeInput type="checkbox" id="owner_confirmation" formControlName="owner_confirmation" [showValidation]="showValidation">
					</eze-input-container>

					<eze-input-container label="*By checking this box I attest that I am of legal adult age or the parent/ legal guardian of the applicant.">
						<input ezeInput type="checkbox" id="legal_age" formControlName="legal_age" [showValidation]="showValidation">
					</eze-input-container>

					<eze-input-container label="*By clicking this box I attest that I have NOT been convicted of a crime involving physical violence or sex-related offenses.">
						<input ezeInput type="checkbox" id="no_crime" formControlName="no_crime" [showValidation]="showValidation">
					</eze-input-container>

					<eze-input-container [label]="null">
						<div>*I consent to the
							<a (click)="openModal($event, 'waiver')">Liability Waiver / Image Release / Medical Treatment</a>
						</div>
						<input ezeInput type="checkbox" id="waiver" formControlName="waiver" [showValidation]="showValidation">
					</eze-input-container>

					<eze-input-container [label]="null">
						<div>*I agree with the
							<a (click)="openModal($event, 'terms')">Terms and Conditions</a>
						</div>
						<input ezeInput type="checkbox" id="terms_and_conditions" formControlName="terms_and_conditions" [showValidation]="showValidation">
					</eze-input-container>

					<eze-input-container label="*By clicking this box I attest that I have read and fully understood the Liability Waiver, the Image Release, the Medical Treatment and the Terms and Conditions. I attest that the information I have provided is true and correct. I understand that this registration will be verified via email and/or phone.">
						<input ezeInput type="checkbox" id="catchall" formControlName="catchall" [showValidation]="showValidation">
					</eze-input-container>


					<button type="subimit" style="display: none;"></button>

				</fieldset>
			</form>
		</div>
	</div>
	<div footer>
		<eze-button (click)="onSubmit()" *ngIf="!successHtml">Register</eze-button>
		<eze-button (click)="resetForm()" *ngIf="successHtml">Claim Another School</eze-button>
	</div>
</eze-smart-form-container>

<eze-waiver #waiverModal [header]="waiverHeader" [waiverText]="waiverText"></eze-waiver>
<eze-terms #termsModal></eze-terms>

<!-- <br>

<pre>invalid = {{ form.invalid | json }}</pre>
<pre>errors = {{ form.errors | json }}</pre>
<pre>form.getError('parent_name_first') = {{ form.getError('parent_name_first') | json }}</pre>

<br> -->
